import script from "./FeatherIcon.vue?vue&type=script&lang=js"
export * from "./FeatherIcon.vue?vue&type=script&lang=js"

import "./FeatherIcon.vue?vue&type=style&index=0&id=b3216f64&lang=scss"

export default script